import { ReactElement } from 'react';

import styles from './points-summary.module.scss';
import { Font } from '@utmb/design-system/text/font';
import SimpleTooltip from '@utmb/design-system/simple-tooltip/SimpleTooltip';
import { ColorTypesEnum } from '@utmb/types/colors';
import { getColorStyle } from '@utmb/utils/colors';
import { useTranslation } from 'next-i18next';

interface PointsSummary {
    value?: number;
}

export function PointsSummary({ value }: PointsSummary): ReactElement {
    const { t } = useTranslation('myutmb');
    return (
        <div className={styles.pointsSummary}>
            <Font.OxaniumBold desktop="52" mobile="52" color={getColorStyle(ColorTypesEnum.WHITE)}>
                {value}
            </Font.OxaniumBold>
            <div>
                <SimpleTooltip message={t('myUtmb.loyalty.history.info')}>
                    <Font.OxaniumBold className={styles.pointsCounter} desktop="18" mobile="18" color={getColorStyle(ColorTypesEnum.WHITE)}>
                        {t('myUtmb.loyalty.points', { count: value ?? 0 })}
                    </Font.OxaniumBold>
                </SimpleTooltip>
                <Font.OxaniumMedium desktop="14" mobile="14" color={getColorStyle(ColorTypesEnum.WHITE)}>
                    {t('myUtmb.loyalty.history.rsTaken')}
                </Font.OxaniumMedium>
            </div>
        </div>
    );
}
